module.exports = __webpack_public_path__ + "img/patientInfo.6c24b37e.svg";